import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, TransitionGroup as _TransitionGroup, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "tb-done" };
const _hoisted_2 = { class: "tb-done-emoji" };
const _hoisted_3 = ["src"];
const _hoisted_4 = { class: "tb-done-buttons" };
const _hoisted_5 = {
    key: 0,
    class: "tb-embed-header"
};
const _hoisted_6 = { class: "tb-embed-title" };
const _hoisted_7 = { class: "tb-swipe-area" };
const _hoisted_8 = {
    key: 0,
    class: "tb-controls"
};
const _hoisted_9 = {
    key: 0,
    class: "tb-group-row"
};
const _hoisted_10 = { class: "tb-group-label" };
const _hoisted_11 = ["src"];
const _hoisted_12 = ["src"];
const _hoisted_13 = {
    key: 3,
    class: "tb-bulk-bar"
};
const _hoisted_14 = {
    key: 2,
    class: "tb-actions"
};
const _hoisted_15 = { class: "tb-actions-title" };
const _hoisted_16 = { class: "tb-toggle-row" };
const _hoisted_17 = { class: "tb-toggle-row" };
const _hoisted_18 = { class: "tb-tag-section" };
const _hoisted_19 = { class: "tb-cta-row" };
const _hoisted_20 = ["disabled"];
const _hoisted_21 = { class: "tb-cta-circle tb-cta-circle--other" };
const _hoisted_22 = ["src"];
const _hoisted_23 = { class: "tb-cta-label" };
const _hoisted_24 = ["disabled"];
const _hoisted_25 = ["src"];
const _hoisted_26 = { class: "tb-cta-label" };
const _hoisted_27 = {
    key: 0,
    class: "tb-suggest-skeleton tb-suggest-skeleton--cta"
};
const _hoisted_28 = { class: "tb-tx-dialog" };
const _hoisted_29 = { class: "tb-tx-dialog-header" };
const _hoisted_30 = { class: "tb-tx-dialog-body" };
const _hoisted_31 = { class: "tb-tx-drawer" };
const _hoisted_32 = { class: "tb-info" };
const _hoisted_33 = { class: "tb-info-section" };
const _hoisted_34 = { class: "tb-info-head" };
const _hoisted_35 = { class: "tb-info-icon" };
const _hoisted_36 = ["src"];
const _hoisted_37 = { class: "tb-exclude-dialog" };
const _hoisted_38 = { class: "tb-exclude-dialog-title" };
const _hoisted_39 = { class: "tb-exclude" };
const _hoisted_40 = { class: "tb-exclude-text" };
const _hoisted_41 = { class: "tb-exclude" };
const _hoisted_42 = { class: "tb-exclude-text" };
import { ref, computed, onMounted, onUnmounted, useTemplateRef, watch, nextTick } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useBanking } from '@/composables/useBanking';
import { useTransactions } from '@/composables/useTransactions';
import { useSpendingAnalysis, getTransactionClassificationTree } from '@/composables/useSpendingAnalysis';
import { selectedAccount } from './elements/spendingAnalysisFilterState';
import { pendingTransactionUpdateId } from './elements/transactionUpdateState';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
import MGToggle from './elements/MGToggle.vue';
import ChangeCategoryDrawer from './elements/ChangeCategoryDrawer.vue';
import ChangeCategoryDialog from '@/desktop/components/ChangeCategoryDialog.vue';
import TransactionGroupCard from './elements/TransactionGroupCard.vue';
import TagInput from './elements/TagInput.vue';
import MGTextField from './elements/MGTextField.vue';
import SimpleDrawerPanel from './elements/SimpleDrawerPanel.vue';
import TransactionsList from './elements/TransactionsList.vue';
import { getCategoryIconUrl, groupByDay, formatTimestamp } from '@/utils/helpers';
import { findUncategorisedId, findGeneralOther, findInTreeById } from '@/utils/classificationTree';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TransactionBulkPage',
    props: {
        embedded: { type: Boolean },
        fromDate: {},
        toDate: {},
        initialCount: {}
    },
    emits: ["close", "transaction-click"],
    setup(__props, { emit: __emit }) {
        const state = useAppState();
        const router = useRouter();
        const route = useRoute();
        useAuth();
        const { getCustomer, getCustomerTags } = useCustomer();
        const { getBankingInfo } = useBanking();
        const transactionsApi = useTransactions();
        useSpendingAnalysis();
        const drawer = useTemplateRef('drawer');
        // `embedded` lets the desktop SpendingAnalysisPage host this whole flow in an
        // overlay: navigation becomes a `close` emit and the date range comes from props
        // instead of the route query. Mobile route behaviour is unchanged when absent.
        const props = __props;
        const emit = __emit;
        const queue = ref([]);
        const index = ref(0);
        const suggestion = ref(null);
        const suggestionLoading = ref(false);
        const fetchingMerchant = ref(null);
        const applying = ref(false);
        const classificationTree = ref(null);
        const alwaysApply = ref(false);
        const excludeFromAnalysis = ref(false);
        const alwaysApplyExcludeInclude = ref(false);
        const excludeDialogVisible = ref(false);
        const revertingExclude = ref(false);
        const appliedCount = ref(0);
        const availableTags = ref(null);
        const grouped = ref(true);
        const groupInfoOpen = ref(false);
        const pageTags = ref([]);
        const completed = ref(false);
        // True while the post-classify poll (returning from TransactionDetailPage) waits
        // for the server to reflect the change — drives the list skeleton.
        const reconciling = ref(false);
        // Disables scroll-snap during the optimistic card-removal animation so the
        // mandatory snap can't yank scrollLeft to the start and stomp the slide-in.
        const snapOff = ref(false);
        // Disable the slide leave/move transition during a full group-by rebuild — those
        // animations exist only for the optimistic single-card removal; on a bulk rebuild
        // the many simultaneous absolute-positioned leaves flicker.
        const suppressSlideAnim = ref(false);
        // Belt-and-braces: hide the scroller during a group-by rebuild so no intermediate
        // frame (e.g. the webview snapping to card 0) is ever painted before we re-centre.
        const scrollerHidden = ref(false);
        let snapTimer = 0;
        let reconcileTimer = 0;
        let revealTimer = 0;
        // Drive the list skeleton with a safety timeout: useApi swallows network errors
        // on the SWR poll path (no onSuccess fires), so without this the skeleton could
        // stick forever if every poll attempt fails. 30s comfortably exceeds the poll
        // budget (5 × 5s).
        function setReconciling(on) {
            clearTimeout(reconcileTimer);
            reconciling.value = on;
            if (on)
                reconcileTimer = window.setTimeout(() => { reconciling.value = false; }, 30000);
        }
        const viewMode = ref('card');
        const listSearch = ref('');
        const returnScrollId = ref(null);
        // Lazily-fetched suggestion per transaction id (for the list swipe action).
        const listSuggestions = ref({});
        // The list transaction(s) a category drawer is acting on (swipe = one, bulk = many).
        const listActionTxs = ref(null);
        // Multi-select mode + chosen transaction ids.
        const selectMode = ref(false);
        const selectedIds = ref(new Set());
        const scroller = useTemplateRef('scroller');
        let scrollRaf = 0;
        let scrollEndTimer = 0;
        let isScrolling = false;
        // Clamp the index so a stale/out-of-range value (e.g. an in-flight scroll during
        // the optimistic card removal) can never make this null while items remain —
        // that would unmount the card area and blank the page.
        const current = computed(() => {
            const q = queue.value;
            if (!q.length)
                return null;
            const i = Math.min(Math.max(index.value, 0), q.length - 1);
            return q[i] ?? null;
        });
        const remainingCount = computed(() => queue.value.reduce((n, g) => n + g.value.length, 0));
        // Until the first fetch resolves, queue is empty so remainingCount is 0 — seed the
        // header from the caller's known count to avoid a "(0)" flash on open.
        const hasLoaded = ref(false);
        const headerTitle = computed(() => {
            const n = hasLoaded.value ? remainingCount.value : props.initialCount;
            return n === undefined ? 'Uncategorised' : `Uncategorised (${n})`;
        });
        const currentMerchantName = computed(() => current.value?.key ?? '');
        const drawerMerchantName = computed(() => {
            const txs = listActionTxs.value;
            if (txs && txs.length === 1)
                return txs[0].merchantName ?? '';
            if (txs && txs.length > 1)
                return '';
            return currentMerchantName.value;
        });
        const txDrawerOpen = ref(false);
        const currentCount = computed(() => current.value?.value.length ?? 0);
        const countLabel = computed(() => `${currentCount.value} transaction${currentCount.value === 1 ? '' : 's'}`);
        const markLabel = computed(() => currentCount.value === 1 ? 'transaction' : `${currentCount.value} transactions`);
        const viewLabel = computed(() => currentCount.value === 1 ? 'transaction' : `${currentCount.value} transactions`);
        const suggestionSub = computed(() => {
            const s = suggestion.value;
            if (!s)
                return '';
            const mg = s.mgClassification;
            const node = (typeof mg === 'object' && mg) ? mg : s;
            return node.mgSubClassification ?? node.fullName ?? '';
        });
        const isOtherSuggestion = computed(() => {
            const sub = suggestionSub.value.toLowerCase();
            return !suggestion.value || sub === 'uncategorised' || sub === 'uncategorized' || sub === 'other';
        });
        const suggestionDisplayLower = computed(() => (suggestionSub.value || 'other').toLowerCase());
        const suggestionDisplayUpper = computed(() => (suggestionSub.value || 'OTHER').toUpperCase());
        // Parent category for an "Other" suggestion — e.g. "Essentials" when the
        // suggested sub is "Essentials > Other". Empty when there's no suggestion at all.
        const suggestionParent = computed(() => {
            const s = suggestion.value;
            if (!s)
                return '';
            const mg = s.mgClassification;
            if (typeof mg === 'object' && mg)
                return mg.mgClassification ?? '';
            if (typeof mg === 'string')
                return mg;
            return '';
        });
        // Label for the green "Assign to …" button when the suggestion is Other/uncategorised.
        // Includes the parent so users can tell which "Other" they're assigning to.
        const otherAssignLabel = computed(() => {
            const parent = suggestionParent.value;
            return parent ? `${parent} (Other)` : 'OTHER';
        });
        const suggestionIconUrl = computed(() => {
            if (isOtherSuggestion.value)
                return '';
            const s = suggestion.value;
            const mg = s?.mgClassification;
            const node = (typeof mg === 'object' && mg) ? mg : s;
            return getCategoryIconUrl(node?.iconPath);
        });
        const suggestionAvatarStyle = computed(() => {
            const s = suggestion.value;
            const mg = s?.mgClassification;
            const node = (typeof mg === 'object' && mg) ? mg : s;
            const colour = node?.color;
            if (!colour)
                return {};
            return { backgroundColor: colour };
        });
        // Flat list view: every still-uncategorised transaction, grouped by day for
        // TransactionsList (same shape as groupedCurrentTransactions).
        const allTransactionsByDay = computed(() => groupByDay(queue.value.flatMap(g => g.value)));
        const filteredTransactionsByDay = computed(() => {
            const q = (listSearch.value ?? '').trim().toLowerCase();
            if (!q)
                return allTransactionsByDay.value;
            return allTransactionsByDay.value
                .map(g => g.filter(t => (t.merchantName ?? '').toLowerCase().includes(q) || String(t.amount).includes(q)))
                .filter(g => g.length > 0);
        });
        const groupedCurrentTransactions = computed(() => groupByDay(current.value?.value ?? []));
        const suggestionName = computed(() => {
            const s = suggestion.value;
            if (!s)
                return '';
            const mg = s.mgClassification;
            const node = (typeof mg === 'object' && mg) ? mg : s;
            const parent = (typeof mg === 'object' && mg) ? (mg.mgClassification ?? '') : (typeof mg === 'string' ? mg : '');
            const sub = node.mgSubClassification ?? '';
            if (parent && sub)
                return `${sub} (${parent})`;
            return sub || parent || node.fullName || 'this category';
        });
        function getAccount(t) {
            const id = t?.bankAccountID ?? t?.bankAccountId;
            return state.bankInfo?.accounts?.find((a) => a.id === id);
        }
        function getGroupAmount(txs) {
            return txs.reduce((sum, t) => sum + t.amount, 0);
        }
        function fetchSuggestion() {
            const merchant = currentMerchantName.value;
            if (!merchant) {
                suggestion.value = null;
                return;
            }
            if (fetchingMerchant.value === merchant)
                return;
            // Clear the previous merchant's suggestion so the loading skeleton shows
            // immediately on swipe instead of briefly displaying stale data (and so the
            // "Assign to …" CTA can't apply the old category to the new merchant).
            suggestion.value = null;
            fetchingMerchant.value = merchant;
            suggestionLoading.value = true;
            transactionsApi.getSuggestedClassification(merchant, (result) => {
                if (fetchingMerchant.value !== merchant)
                    return;
                const groupAmount = current.value ? getGroupAmount(current.value.value) : 0;
                suggestion.value = resolveSuggestion(result, groupAmount);
                suggestionLoading.value = false;
                fetchingMerchant.value = null;
            });
        }
        function onYes() {
            if (!suggestion.value || applying.value)
                return;
            apply({
                classification: suggestion.value,
                alwaysApply: alwaysApply.value,
                excludeFromAnalysis: excludeFromAnalysis.value,
                alwaysApplyExcludeInclude: alwaysApplyExcludeInclude.value,
            });
        }
        function onNo() {
            if (applying.value)
                return;
            listActionTxs.value = null;
            drawer.value?.openDrawer();
        }
        function onPickedFromDrawer(payload) {
            if (!payload.classification) {
                listActionTxs.value = null;
                drawer.value?.closeDrawer();
                return;
            }
            apply(payload);
        }
        // ---- Multi-select ----
        // Select (enter mode) → Deselect all (clear, stay in mode) → Cancel (exit).
        const selectButtonText = computed(() => {
            if (!selectMode.value)
                return 'Select';
            return selectedIds.value.size ? 'Deselect all' : 'Cancel';
        });
        function onSelectButton() {
            if (!selectMode.value) {
                selectMode.value = true;
            }
            else if (selectedIds.value.size) {
                selectedIds.value = new Set();
            }
            else {
                selectMode.value = false;
            }
        }
        function onToggleSelect(t) {
            if (applying.value)
                return;
            const next = new Set(selectedIds.value);
            if (next.has(t.id))
                next.delete(t.id);
            else
                next.add(t.id);
            selectedIds.value = next;
        }
        function onToggleDay(g) {
            if (applying.value)
                return;
            const ids = g.map((t) => t.id);
            const allSelected = ids.every(id => selectedIds.value.has(id));
            const next = new Set(selectedIds.value);
            for (const id of ids) {
                if (allSelected)
                    next.delete(id);
                else
                    next.add(id);
            }
            selectedIds.value = next;
        }
        function onBulkMark() {
            const ids = selectedIds.value;
            if (!ids.size)
                return;
            listActionTxs.value = queue.value.flatMap(g => g.value).filter((t) => ids.has(t.id));
            drawer.value?.openDrawer();
        }
        // ---- List view swipe actions ----
        // Build {name, iconUrl, color} for the suggested-category swipe button — same
        // derivation the card CTA uses (mg-object node, sub-classification, colour).
        function suggestionInfo(s) {
            const mg = s?.mgClassification;
            const node = (typeof mg === 'object' && mg) ? mg : s;
            const sub = node?.mgSubClassification ?? node?.fullName ?? '';
            return {
                name: sub || 'Other',
                iconUrl: getCategoryIconUrl(node?.iconPath),
                color: node?.color ?? '',
            };
        }
        // Resolve a raw suggestion to a tree node, applying the backend workaround:
        // Income/Other is returned for unmatched merchants regardless of direction —
        // swap to General/Other for spend (negative amount).
        function resolveSuggestion(result, amount) {
            if (!result)
                return null;
            let node = result;
            if (result.id && classificationTree.value) {
                node = findInTreeById(result.id, classificationTree.value) ?? result;
            }
            const mg = node?.mgClassification;
            const parentName = typeof mg === 'object' && mg ? mg.mgClassification : mg;
            const subName = node?.mgSubClassification ?? (typeof mg === 'object' && mg ? mg.mgSubClassification : undefined);
            if (parentName === 'Income' && subName === 'Other' && amount < 0 && classificationTree.value) {
                const generalOther = findGeneralOther(classificationTree.value);
                if (generalOther)
                    node = generalOther;
            }
            return node;
        }
        function onListSwipeOpen(t) {
            if (listSuggestions.value[t.id])
                return;
            const merchant = t.merchantName;
            if (!merchant)
                return;
            listSuggestions.value = { ...listSuggestions.value, [t.id]: { loading: true } };
            transactionsApi.getSuggestedClassification(merchant, (result) => {
                const node = resolveSuggestion(result, t.amount);
                listSuggestions.value = { ...listSuggestions.value, [t.id]: { classification: node, loading: false, ...suggestionInfo(node) } };
            });
        }
        function onListApplySuggestion(t) {
            const s = listSuggestions.value[t.id];
            if (!s?.classification)
                return;
            // Fire the write in the background and drop the row immediately (optimistic).
            transactionsApi.applyCategoryToTransactions([t], {
                classification: s.classification,
                alwaysApply: false,
                excludeFromAnalysis: false,
                alwaysApplyExcludeInclude: false,
            }, () => { appliedCount.value += 1; });
            removeTxsOptimistic([t], false);
        }
        function onListOpenCategory(t) {
            listActionTxs.value = [t];
            drawer.value?.openDrawer();
        }
        // Apply tags to the current group as soon as one is added/removed — fire and
        // forget, no need to wait for the Assign CTA. The endpoint replaces the full
        // tag list, so sending the current selection handles both add and remove.
        function onPageTagsChange(tags) {
            pageTags.value = tags;
            const group = current.value;
            if (!group)
                return;
            const payload = tags.map(tag => ({ tag }));
            for (const tx of group.value) {
                // Keep the in-memory model in sync so re-visiting the card shows the tags.
                tx.customerTags = payload.slice();
                transactionsApi.updateTransactionTags(tx.bankAccountID ?? tx.bankAccountId, tx.id, payload);
            }
        }
        function applyTagsToGroup(txs, tags, done) {
            if (!tags.length) {
                done();
                return;
            }
            const payload = tags.map(tag => ({ tag }));
            let remaining = txs.length;
            if (!remaining) {
                done();
                return;
            }
            for (const tx of txs) {
                transactionsApi.updateTransactionTags(tx.bankAccountID ?? tx.bankAccountId, tx.id, payload, () => {
                    remaining -= 1;
                    if (remaining === 0)
                        done();
                });
            }
        }
        function apply(payload) {
            // In list view the target is the swipe/bulk selection; in card view the group.
            const txs = listActionTxs.value ?? current.value?.value;
            if (!txs || !txs.length)
                return;
            const isList = !!listActionTxs.value;
            const writeTxs = txs.slice();
            // An "always apply" rule categorises the whole merchant server-side, so every
            // card/row for that merchant should leave too — not just the actioned ones.
            const ruleMerchant = payload.alwaysApply ? (writeTxs[0]?.merchantName || undefined) : undefined;
            // Run the write in the background; the queue updates optimistically below so
            // the actioned items disappear immediately without waiting on the server.
            transactionsApi.applyCategoryToTransactions(writeTxs, payload, () => {
                applyTagsToGroup(writeTxs, payload.tags ?? [], () => { appliedCount.value += writeTxs.length; });
            });
            if (isList) {
                resetActionState();
                removeTxsOptimistic(writeTxs, !!payload.alwaysApply);
            }
            else {
                advanceOptimistic(ruleMerchant);
            }
        }
        // List-view optimistic removal: drop the actioned transactions from the queue by
        // id, plus — for an "always apply" rule — every remaining tx of those merchants
        // (the rule clears them server-side). Empty day/merchant groups fall away.
        function removeTxsOptimistic(txs, isRule) {
            const ids = new Set(txs.map((t) => t.id));
            const merchants = isRule ? new Set(txs.map((t) => t.merchantName).filter(Boolean)) : null;
            const remove = (x) => ids.has(x.id) || (merchants ? merchants.has(x.merchantName) : false);
            const groups = queue.value
                .map(g => ({ ...g, value: g.value.filter((x) => !remove(x)) }))
                .filter(g => g.value.length > 0);
            queue.value = groups;
            if (!groups.length) {
                completed.value = true;
                return;
            }
            if (index.value >= groups.length)
                index.value = groups.length - 1;
        }
        // Card/swipe view optimistic advance: reset the action panel and drop the actioned
        // card(s) from the queue right away so the next card appears without a server
        // round-trip. Pass `removeMerchant` (set for an "always apply" rule) to sweep every
        // card for that merchant; otherwise just the current card goes.
        function advanceOptimistic(removeMerchant) {
            drawer.value?.closeDrawer();
            alwaysApply.value = false;
            revertingExclude.value = true;
            excludeFromAnalysis.value = false;
            alwaysApplyExcludeInclude.value = false;
            excludeDialogVisible.value = false;
            const removedIdx = index.value;
            const isRemoved = (g, i) => removeMerchant ? g.key === removeMerchant : i === removedIdx;
            // Anchor on the first surviving card at/after the current position so we keep our
            // place; fall back to the last survivor when the tail was removed.
            let anchor = null;
            for (let i = removedIdx + 1; i < queue.value.length; i++) {
                if (!isRemoved(queue.value[i], i)) {
                    anchor = queue.value[i];
                    break;
                }
            }
            const survivors = queue.value.filter((g, i) => !isRemoved(g, i));
            if (!survivors.length) {
                // Nothing left — show the success screen.
                queue.value = [];
                completed.value = true;
                return;
            }
            // Suspend scroll-snap for the animation: with it on, the mandatory snap yanks
            // scrollLeft to the start on the content change and the slide-in never shows.
            snapOff.value = true;
            queue.value = survivors;
            index.value = anchor ? survivors.indexOf(anchor) : survivors.length - 1;
            // Re-centre the now-current card. A single mid-list removal lands on the same
            // scroll position (no-op), but a merchant sweep can drop cards before it.
            nextTick(() => scrollToIndex(index.value));
            // Re-enable snap once the move/leave transition (0.28s) has settled. Clear any
            // pending timer first so a rapid second action can't re-enable snap mid-way
            // through this card's animation (which would re-trigger the snap-to-start jump).
            clearTimeout(snapTimer);
            snapTimer = window.setTimeout(() => { snapOff.value = false; }, 350);
        }
        // Reset the action panel/selection after a list apply (the queue is updated
        // separately by removeTxsOptimistic).
        function resetActionState() {
            drawer.value?.closeDrawer();
            alwaysApply.value = false;
            revertingExclude.value = true;
            excludeFromAnalysis.value = false;
            alwaysApplyExcludeInclude.value = false;
            excludeDialogVisible.value = false;
            listActionTxs.value = null;
            selectMode.value = false;
            selectedIds.value = new Set();
        }
        // Native scroll-snap drives navigation; track which slide is centred so the
        // suggestion row + Assign CTA stay in sync with the visible card.
        function onScroll() {
            // Mark the swipe as in-flight and only fetch the suggestion/tags once the
            // scroll has been quiet for 200ms — a fast swipe never settles, so no calls
            // fire for the cards it flies past.
            isScrolling = true;
            clearTimeout(scrollEndTimer);
            scrollEndTimer = window.setTimeout(() => {
                isScrolling = false;
                if (current.value) {
                    fetchSuggestion();
                    refreshTags();
                }
            }, 200);
            if (scrollRaf)
                return;
            scrollRaf = requestAnimationFrame(() => {
                scrollRaf = 0;
                const el = scroller.value;
                if (!el)
                    return;
                const centre = el.scrollLeft + el.clientWidth / 2;
                // Exclude any card mid-leave (position:absolute during the optimistic
                // removal) so the indices stay aligned with `queue` — otherwise `best` can
                // run past the queue length and make `current` null, blanking the page.
                const slides = el.querySelectorAll('.tb-slide:not(.tb-slide-leave-active)');
                let best = 0;
                let bestD = Infinity;
                for (let i = 0; i < slides.length; i++) {
                    const s = slides[i];
                    const d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - centre);
                    if (d < bestD) {
                        bestD = d;
                        best = i;
                    }
                }
                if (best !== index.value && best < queue.value.length)
                    index.value = best;
            });
        }
        function scrollToIndex(i) {
            const el = scroller.value;
            if (!el)
                return;
            // Exclude any card mid-leave: during the optimistic removal it's still in the
            // DOM but position:absolute, so it throws off both child indexing and offsetLeft.
            const slides = el.querySelectorAll('.tb-slide:not(.tb-slide-leave-active)');
            const s = slides[i];
            if (!s)
                return;
            el.scrollTo({ left: s.offsetLeft - (el.clientWidth - s.offsetWidth) / 2 });
        }
        function onBack() {
            if (props.embedded) {
                emit('close', appliedCount.value);
                return;
            }
            if (appliedCount.value > 0) {
                sessionStorage.setItem('saCategorisedToast', String(appliedCount.value));
            }
            router.replace('/SpendingAnalysis');
        }
        function goHome() {
            router.replace('/');
        }
        // Remember the view so returning from TransactionDetail lands back on the list
        // instead of resetting to the card view.
        function openTransaction(t) {
            // Embedded (desktop): hand the click to the host so it opens its own
            // lightweight transaction dialog instead of the full-screen mobile detail page.
            if (props.embedded) {
                emit('transaction-click', t);
                return;
            }
            sessionStorage.setItem('tbReturnView', viewMode.value);
            if (t?.id)
                sessionStorage.setItem('tbReturnScrollId', t.id);
            router.push('/TransactionDetail/' + t.id);
        }
        // Re-fetch the selectable customer tags so any tag just created on a previous
        // card is available, and pre-fill the input with the new card's existing tags.
        function refreshTags() {
            getCustomerTags(() => {
                availableTags.value = (state.customerTags ?? []).map((ct) => ct.tag);
            });
        }
        function loadTagsForCurrent() {
            const txs = current.value?.value ?? [];
            const tags = new Set();
            for (const t of txs)
                for (const ct of (t.customerTags ?? []))
                    if (ct.tag)
                        tags.add(ct.tag);
            pageTags.value = [...tags];
        }
        watch(current, () => {
            if (!current.value)
                return;
            loadTagsForCurrent();
            // Clear the old card's suggestion into a loading state the moment we leave it —
            // otherwise the stale suggestion lingers on the CTA until the new fetch settles.
            suggestion.value = null;
            suggestionLoading.value = true;
            fetchingMerchant.value = null;
            // While swiping, the scroll-stop handler fires the suggestion/tags calls once
            // the card lands. Only fetch here for non-swipe changes (initial load, reconcile).
            if (!isScrolling) {
                fetchSuggestion();
                refreshTags();
            }
        });
        // Guards the drawer's dismiss handler: true once a button (Yes/No/Back) settles
        // the choice, so closing via the X or swipe-down doesn't double-revert.
        let excludeDecided = false;
        watch(excludeFromAnalysis, () => {
            if (revertingExclude.value) {
                revertingExclude.value = false;
                return;
            }
            alwaysApplyExcludeInclude.value = false;
            excludeDecided = false;
            excludeDialogVisible.value = true;
        });
        function confirmAlwaysExcludeInclude(always) {
            excludeDecided = true;
            alwaysApplyExcludeInclude.value = always;
            excludeDialogVisible.value = false;
        }
        function cancelExcludeChange() {
            excludeDecided = true;
            revertingExclude.value = true;
            excludeFromAnalysis.value = !excludeFromAnalysis.value;
            excludeDialogVisible.value = false;
        }
        // Closing the drawer via the X / swipe-down (no button) is treated as "Back".
        function onExcludeDrawerToggle(open) {
            if (open || excludeDecided)
                return;
            cancelExcludeChange();
        }
        function groupByMerchant(txs) {
            const map = new Map();
            for (const t of txs) {
                const key = t.merchantName || 'Unknown';
                const arr = map.get(key) ?? [];
                arr.push(t);
                map.set(key, arr);
            }
            const groups = [];
            map.forEach((value, key) => groups.push({ key, value }));
            groups.sort((a, b) => new Date(b.value[0].timestamp).getTime() - new Date(a.value[0].timestamp).getTime());
            return groups;
        }
        // One card per merchant when grouping is on, otherwise one card per transaction.
        function buildGroups(txs) {
            if (grouped.value)
                return groupByMerchant(txs);
            return txs
                .slice()
                .sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime())
                .map(t => ({ key: t.merchantName || 'Unknown', value: [t] }));
        }
        // Re-shape the still-uncategorised transactions when the toggle flips, keeping
        // progress (already-applied cards stay gone).
        function rebuildQueue() {
            // Anchor on the transaction currently in view so the toggle keeps our place.
            const anchorTxId = current.value?.value[0]?.id;
            const remaining = queue.value.flatMap(g => g.value);
            suppressSlideAnim.value = true;
            // Suspend scroll-snap: with it on, the mandatory snap yanks scrollLeft to the
            // start (card 0) on the content change, flashing the first card before we
            // re-centre on the anchored one.
            snapOff.value = true;
            // And hide the scroller until it's re-centred, so even a stray paint mid-swap
            // (the webview snapping before our scrollToIndex lands) is never visible.
            scrollerHidden.value = true;
            queue.value = buildGroups(remaining);
            const newIdx = anchorTxId
                ? queue.value.findIndex(g => g.value.some(t => t.id === anchorTxId))
                : -1;
            index.value = newIdx >= 0 ? newIdx : 0;
            nextTick(() => {
                scrollToIndex(index.value);
                // Re-enable so a subsequent apply still animates its card out.
                suppressSlideAnim.value = false;
                // Reveal once the fade-out has finished (matches the 0.15s opacity transition),
                // by which point the scroll re-centre is long committed — so the cards fade
                // fully out then back in with no card-0 flash.
                clearTimeout(revealTimer);
                revealTimer = window.setTimeout(() => { scrollerHidden.value = false; }, 150);
            });
            clearTimeout(snapTimer);
            snapTimer = window.setTimeout(() => { snapOff.value = false; }, 350);
        }
        watch(grouped, rebuildQueue);
        function selectedAccountIdsForRequest() {
            const key = selectedAccount.value;
            const accounts = (state.bankInfo?.accounts || []).filter((a) => a.source === 0);
            if (!accounts.length || key === 'all')
                return undefined;
            const typeMap = { current: 'Current', credit: 'Credit', savings: 'Savings' };
            if (typeMap[key]) {
                const ids = accounts.filter((a) => a.accountType?.prettyName === typeMap[key]).map((a) => a.id);
                return ids.length ? ids : undefined;
            }
            const match = accounts.find((a) => a.id === key);
            return match ? [match.id] : undefined;
        }
        function rangeFromQuery() {
            const f = route.query.from;
            const t = route.query.to;
            if (typeof f !== 'string' || typeof t !== 'string')
                return null;
            if (Number.isNaN(new Date(f).getTime()) || Number.isNaN(new Date(t).getTime()))
                return null;
            return { from: f, to: t };
        }
        function currentCycleRange() {
            // Always operates on the current pay cycle, matching the master page and
            // the `untaggedTransactionsCurrentCycleCount` indicator shown on Home/Activity.
            const now = new Date();
            const cycleDay = state.bankInfo?.spendingCycle?.day ?? 1;
            let endY = now.getUTCFullYear();
            let endM = now.getUTCMonth();
            if (now.getUTCDate() >= cycleDay) {
                endM += 1;
                if (endM > 11) {
                    endM = 0;
                    endY += 1;
                }
            }
            let startY = endY;
            let startM = endM - 1;
            if (startM < 0) {
                startM = 11;
                startY -= 1;
            }
            return {
                fromDate: new Date(Date.UTC(startY, startM, cycleDay)),
                toDate: new Date(Date.UTC(endY, endM, cycleDay)),
            };
        }
        function loadUncategorised() {
            // A category change made on TransactionDetailPage leaves this marker. When set,
            // the server's cached uncategorised list may not have invalidated yet — a single
            // refresh would return the old list (still showing the just-classified tx). So
            // SWR + pollUntilChanged instead: skip the stale snapshot (show the skeleton)
            // and rebuild only once the payload hash flips. Consume the marker (one-shot).
            const pollForWrite = pendingTransactionUpdateId.value !== null;
            pendingTransactionUpdateId.value = null;
            setReconciling(pollForWrite);
            let loaded = false;
            getTransactionClassificationTree((tree) => {
                classificationTree.value = tree;
                if (loaded)
                    return;
                loaded = true;
                const uncatId = findUncategorisedId(tree);
                if (!uncatId) {
                    console.warn('[TransactionBulkPage] could not find Uncategorised classification in tree', tree);
                    if (props.embedded)
                        emit('close', appliedCount.value);
                    else
                        router.replace('/SpendingAnalysis');
                    return;
                }
                // Embedded passes the range as props; otherwise the caller may pass `from`/`to`
                // in the URL (e.g. SpendingAnalysisPage linking to a historical month), falling
                // back to the current cycle. Server-supplied range strings go through verbatim:
                // a new Date(...).toISOString() round-trip parses them in the browser timezone,
                // which can shift the end date back a day and drop the window's final day.
                const cycle = () => {
                    const r = currentCycleRange();
                    return { from: r.fromDate.toISOString(), to: r.toDate.toISOString() };
                };
                const { from, to } = (props.embedded && props.fromDate && props.toDate)
                    ? { from: props.fromDate, to: props.toDate }
                    : (rangeFromQuery() ?? cycle());
                transactionsApi.getTransactions(uncatId, from, to, (result, isStale) => {
                    if (pollForWrite && isStale)
                        return;
                    setReconciling(false);
                    hasLoaded.value = true;
                    const all = (result?.transactions) ?? [];
                    // getTransactions has no account filter — apply client-side using the
                    // same `selectedAccount` filter the user picked on SpendingAnalysisPage.
                    const accountIds = selectedAccountIdsForRequest();
                    const filtered = accountIds
                        ? all.filter(t => accountIds.includes(t.bankAccountID ?? t.bankAccountId))
                        : all;
                    const groups = buildGroups(filtered);
                    if (!groups.length) {
                        // Cleared the last one via a classify on TDP → show the success page.
                        // A cold entry with nothing to categorise bounces back (close when embedded).
                        if (pollForWrite)
                            completed.value = true;
                        else if (props.embedded)
                            emit('close', appliedCount.value);
                        else
                            router.replace('/SpendingAnalysis');
                        return;
                    }
                    index.value = 0;
                    queue.value = groups;
                }, /* includeChildren */ false, /* refreshCache */ !pollForWrite, /* includeExcludedFromAnalysis */ true, /* staleWhileRevalidate */ pollForWrite, /* pollUntilChanged */ pollForWrite);
            }, /* refreshCache */ true);
        }
        onMounted(() => {
            const rv = sessionStorage.getItem('tbReturnView');
            if (rv === 'list' || rv === 'card') {
                viewMode.value = rv;
                sessionStorage.removeItem('tbReturnView');
            }
            returnScrollId.value = sessionStorage.getItem('tbReturnScrollId');
            sessionStorage.removeItem('tbReturnScrollId');
            getCustomer(() => {
                getBankingInfo(() => {
                    loadUncategorised();
                });
            });
            refreshTags();
        });
        onUnmounted(() => {
            clearTimeout(snapTimer);
            clearTimeout(reconcileTimer);
            clearTimeout(revealTimer);
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            const _component_v_dialog = _resolveComponent("v-dialog");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (completed.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (!_ctx.embedded)
                            ? (_openBlock(), _createBlock(HeaderBlock, {
                                key: 0,
                                title: "",
                                border: false,
                                logicalBack: true,
                                onLogicalBack: onBack
                            }))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("img", {
                                    src: require('@/assets/tada.gif'),
                                    alt: "Celebration",
                                    class: "tb-done-tada"
                                }, null, 8, _hoisted_3)
                            ]),
                            _cache[17] || (_cache[17] = _createElementVNode("h2", { class: "tb-done-title" }, "You have organised all of your uncategorised transactions", -1)),
                            _createElementVNode("div", _hoisted_4, [
                                _createVNode(MGButton, {
                                    text: "Return to spending analysis",
                                    noCaps: true,
                                    arrow: true,
                                    fullWidth: true,
                                    onClick: onBack
                                }),
                                (!_ctx.embedded)
                                    ? (_openBlock(), _createBlock(MGButton, {
                                        key: 0,
                                        text: "Go home",
                                        noCaps: true,
                                        outline: true,
                                        stacked: true,
                                        fullWidth: true,
                                        onClick: goHome
                                    }))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_ctx.embedded)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createElementVNode("span", _hoisted_6, _toDisplayString(headerTitle.value), 1),
                                _createElementVNode("button", {
                                    class: "tb-embed-close",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (emit('close', appliedCount.value)))
                                }, [
                                    _createVNode(_component_v_icon, { size: "18" }, {
                                        default: _withCtx(() => _cache[18] || (_cache[18] = [
                                            _createTextVNode("mdi-close")
                                        ])),
                                        _: 1
                                    })
                                ])
                            ]))
                            : (_openBlock(), _createBlock(HeaderBlock, {
                                key: 1,
                                title: headerTitle.value,
                                border: false,
                                logicalBack: true,
                                onLogicalBack: onBack
                            }, null, 8, ["title"])),
                        _createElementVNode("div", _hoisted_7, [
                            (current.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    (viewMode.value === 'card')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                            _createElementVNode("span", _hoisted_10, [
                                                _cache[19] || (_cache[19] = _createTextVNode(" Group by merchant ")),
                                                _createElementVNode("img", {
                                                    src: require('@/assets/i.png'),
                                                    alt: "Info",
                                                    class: "tb-group-info",
                                                    onClick: _cache[1] || (_cache[1] = ($event) => (groupInfoOpen.value = true))
                                                }, null, 8, _hoisted_11)
                                            ]),
                                            _createVNode(MGToggle, {
                                                modelValue: grouped.value,
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((grouped).value = $event)),
                                                tick: true
                                            }, null, 8, ["modelValue"])
                                        ]))
                                        : (_openBlock(), _createBlock(MGTextField, {
                                            key: 1,
                                            modelValue: listSearch.value,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((listSearch).value = $event)),
                                            class: "tb-search",
                                            "prepend-inner-icon": "mdi-magnify",
                                            placeholder: "Search",
                                            density: "compact",
                                            variant: "solo",
                                            flat: true,
                                            "hide-details": "",
                                            clearable: "",
                                            "single-line": "",
                                            "bg-color": "#eeeeee"
                                        }, null, 8, ["modelValue"])),
                                    (viewMode.value === 'list')
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 2,
                                            class: "tb-select-btn",
                                            onClick: onSelectButton
                                        }, _toDisplayString(selectButtonText.value), 1))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["tb-view-toggle", { 'tb-view-toggle--hidden': selectMode.value }]),
                                        onClick: _cache[4] || (_cache[4] = ($event) => (viewMode.value = viewMode.value === 'card' ? 'list' : 'card'))
                                    }, [
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["tb-view-thumb", { 'tb-view-thumb--list': viewMode.value === 'list' }]),
                                            "aria-hidden": "true"
                                        }, null, 2),
                                        _createElementVNode("button", {
                                            class: _normalizeClass(["tb-view-opt", { 'tb-view-opt--selected': viewMode.value === 'card' }]),
                                            "aria-label": "Swipe view"
                                        }, [
                                            _createElementVNode("img", {
                                                src: require('@/assets/transactions/swipe.png'),
                                                class: "tb-view-icon",
                                                alt: ""
                                            }, null, 8, _hoisted_12)
                                        ], 2),
                                        _createElementVNode("button", {
                                            class: _normalizeClass(["tb-view-opt", { 'tb-view-opt--selected': viewMode.value === 'list' }]),
                                            "aria-label": "List view"
                                        }, _cache[20] || (_cache[20] = [
                                            _createElementVNode("svg", {
                                                class: "tb-view-icon tb-view-list",
                                                viewBox: "0 0 40 40",
                                                fill: "currentColor",
                                                "aria-hidden": "true"
                                            }, [
                                                _createElementVNode("rect", {
                                                    x: "5",
                                                    y: "9",
                                                    width: "30",
                                                    height: "6",
                                                    rx: "3"
                                                }),
                                                _createElementVNode("rect", {
                                                    x: "5",
                                                    y: "17",
                                                    width: "30",
                                                    height: "6",
                                                    rx: "3"
                                                }),
                                                _createElementVNode("rect", {
                                                    x: "5",
                                                    y: "25",
                                                    width: "30",
                                                    height: "6",
                                                    rx: "3"
                                                })
                                            ], -1)
                                        ]), 2)
                                    ], 2)
                                ]))
                                : _createCommentVNode("", true),
                            (viewMode.value === 'card')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    (current.value && _unref(state).bankInfo)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            ref_key: "scroller",
                                            ref: scroller,
                                            class: _normalizeClass(["tb-scroll", { 'tb-scroll--hidden': scrollerHidden.value }]),
                                            style: _normalizeStyle({ scrollSnapType: snapOff.value ? 'none' : '' }),
                                            onScroll: onScroll
                                        }, [
                                            _createVNode(_TransitionGroup, {
                                                name: suppressSlideAnim.value ? '' : 'tb-slide'
                                            }, {
                                                default: _withCtx(() => [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(queue.value, (g, i) => {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                            class: "tb-slide",
                                                            key: g.value[0].id
                                                        }, [
                                                            _createVNode(TransactionGroupCard, {
                                                                account: getAccount(g.value[0]),
                                                                merchant: g.key,
                                                                amount: getGroupAmount(g.value),
                                                                latestAmount: g.value[0].amount,
                                                                date: g.value[0].timestampFormatted ?? _unref(formatTimestamp)(g.value[0].timestamp),
                                                                rawDate: g.value[0].timestamp,
                                                                count: g.value.length,
                                                                selected: i === index.value,
                                                                formatter: _unref(state).formatter,
                                                                transactionId: g.value[0].id,
                                                                description: g.value[0].description,
                                                                tx: g.value[0],
                                                                onViewTransactions: _cache[5] || (_cache[5] = ($event) => (txDrawerOpen.value = true))
                                                            }, null, 8, ["account", "merchant", "amount", "latestAmount", "date", "rawDate", "count", "selected", "formatter", "transactionId", "description", "tx"])
                                                        ]));
                                                    }), 128))
                                                ]),
                                                _: 1
                                            }, 8, ["name"])
                                        ], 38))
                                        : _createCommentVNode("", true)
                                ], 64))
                                : (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    class: _normalizeClass(["tb-list", { 'tb-list--select': selectMode.value }])
                                }, [
                                    (reconciling.value)
                                        ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                                            key: 0,
                                            type: "list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line",
                                            class: "tb-list-skeleton"
                                        }))
                                        : (filteredTransactionsByDay.value.length)
                                            ? (_openBlock(), _createBlock(TransactionsList, {
                                                key: 1,
                                                search: false,
                                                transactions: filteredTransactionsByDay.value,
                                                formatter: _unref(state).formatter,
                                                today: _unref(state).today,
                                                yesterday: _unref(state).yesterday,
                                                dateInsteadOfCategory: true,
                                                trailingArrow: true,
                                                dividingLines: true,
                                                scrollToId: returnScrollId.value,
                                                swipeActions: !selectMode.value,
                                                clickToReveal: _ctx.embedded,
                                                selectable: selectMode.value,
                                                selectedIds: selectedIds.value,
                                                suggestions: listSuggestions.value,
                                                onTransactionClick: openTransaction,
                                                onSwipeOpen: onListSwipeOpen,
                                                onApplySuggestion: onListApplySuggestion,
                                                onOpenCategory: onListOpenCategory,
                                                onToggleSelect: onToggleSelect,
                                                onToggleDay: onToggleDay
                                            }, null, 8, ["transactions", "formatter", "today", "yesterday", "scrollToId", "swipeActions", "clickToReveal", "selectable", "selectedIds", "suggestions"]))
                                            : _createCommentVNode("", true)
                                ], 2)),
                            (selectMode.value && selectedIds.value.size > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createVNode(MGButton, {
                                        text: applying.value ? 'Working...' : `Mark ${selectedIds.value.size} selected as...`,
                                        fullWidth: true,
                                        disabled: applying.value,
                                        onClick: onBulkMark
                                    }, null, 8, ["text", "disabled"])
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        (current.value && viewMode.value === 'card')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, "Mark " + _toDisplayString(markLabel.value) + " as", 1),
                                _createElementVNode("div", _hoisted_16, [
                                    _cache[21] || (_cache[21] = _createElementVNode("span", null, "Always apply to merchant", -1)),
                                    _createVNode(MGToggle, {
                                        modelValue: alwaysApply.value,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((alwaysApply).value = $event)),
                                        tick: true
                                    }, null, 8, ["modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_17, [
                                    _cache[22] || (_cache[22] = _createElementVNode("span", null, "Exclude from Spending Analysis", -1)),
                                    _createVNode(MGToggle, {
                                        modelValue: excludeFromAnalysis.value,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((excludeFromAnalysis).value = $event)),
                                        tick: true
                                    }, null, 8, ["modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_18, [
                                    _cache[23] || (_cache[23] = _createElementVNode("h3", { class: "tb-tag-heading" }, "Add a transaction tag", -1)),
                                    _createVNode(TagInput, {
                                        selectableTags: availableTags.value ?? [],
                                        modelValue: pageTags.value,
                                        maxTags: 5,
                                        maxTagLength: 20,
                                        placeholder: "Tag limit reached — remove one to add another",
                                        chipsBelow: true,
                                        onChange: onPageTagsChange
                                    }, null, 8, ["selectableTags", "modelValue"]),
                                    _cache[24] || (_cache[24] = _createElementVNode("p", { class: "tb-tag-help" }, "Find your transaction tags on the Activity page. Try using them to group transactions from a holiday, or project.", -1))
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                    (!suggestionLoading.value && isOtherSuggestion.value)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("button", {
                                                class: "tb-cta",
                                                disabled: applying.value,
                                                onClick: onYes
                                            }, [
                                                _createElementVNode("div", _hoisted_21, [
                                                    _createElementVNode("img", {
                                                        src: require('@/assets/transactions/other.png'),
                                                        class: "tb-cta-other-icon",
                                                        alt: ""
                                                    }, null, 8, _hoisted_22)
                                                ]),
                                                _createElementVNode("div", _hoisted_23, [
                                                    _cache[25] || (_cache[25] = _createTextVNode("Mark as")),
                                                    _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
                                                    _createTextVNode(_toDisplayString(otherAssignLabel.value), 1)
                                                ])
                                            ], 8, _hoisted_20),
                                            _createElementVNode("button", {
                                                class: "tb-cta",
                                                onClick: onNo
                                            }, _cache[27] || (_cache[27] = [
                                                _createElementVNode("div", { class: "tb-cta-circle tb-cta-circle--choose" }, [
                                                    _createElementVNode("span", {
                                                        class: "tb-cta-plus",
                                                        "aria-hidden": "true"
                                                    })
                                                ], -1),
                                                _createElementVNode("div", { class: "tb-cta-label" }, [
                                                    _createTextVNode("Choose a"),
                                                    _createElementVNode("br"),
                                                    _createTextVNode("category")
                                                ], -1)
                                            ]))
                                        ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createElementVNode("button", {
                                                class: "tb-cta",
                                                onClick: onNo
                                            }, _cache[28] || (_cache[28] = [
                                                _createElementVNode("div", { class: "tb-cta-circle tb-cta-circle--choose" }, [
                                                    _createElementVNode("span", {
                                                        class: "tb-cta-plus",
                                                        "aria-hidden": "true"
                                                    })
                                                ], -1),
                                                _createElementVNode("div", { class: "tb-cta-label" }, [
                                                    _createTextVNode("Choose a"),
                                                    _createElementVNode("br"),
                                                    _createTextVNode("category")
                                                ], -1)
                                            ])),
                                            _createElementVNode("button", {
                                                class: "tb-cta",
                                                disabled: suggestionLoading.value || !suggestion.value || applying.value,
                                                onClick: onYes
                                            }, [
                                                _createElementVNode("div", {
                                                    class: _normalizeClass(["tb-cta-circle tb-cta-circle--assign", { 'tb-cta-circle--loading': suggestionLoading.value || applying.value }]),
                                                    style: _normalizeStyle((suggestionLoading.value || applying.value) ? {} : suggestionAvatarStyle.value)
                                                }, [
                                                    (suggestionLoading.value || applying.value)
                                                        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                                            key: 0,
                                                            indeterminate: "",
                                                            size: "24",
                                                            width: "2",
                                                            color: "white"
                                                        }))
                                                        : (suggestionIconUrl.value)
                                                            ? (_openBlock(), _createElementBlock("img", {
                                                                key: 1,
                                                                src: suggestionIconUrl.value,
                                                                class: "tb-cta-tick-icon",
                                                                alt: ""
                                                            }, null, 8, _hoisted_25))
                                                            : _createCommentVNode("", true)
                                                ], 6),
                                                _createElementVNode("div", _hoisted_26, [
                                                    _cache[29] || (_cache[29] = _createTextVNode(" Mark as")),
                                                    _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1)),
                                                    (suggestionLoading.value)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_27))
                                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                            _createTextVNode(_toDisplayString(suggestionDisplayUpper.value), 1)
                                                        ], 64))
                                                ])
                                            ], 8, _hoisted_24)
                                        ], 64))
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ], 64)),
                (_ctx.embedded)
                    ? (_openBlock(), _createBlock(_component_v_dialog, {
                        key: 2,
                        modelValue: txDrawerOpen.value,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((txDrawerOpen).value = $event)),
                        "max-width": "520",
                        scrim: "rgba(0, 0, 0, 0.5)"
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("div", _hoisted_29, [
                                    _cache[32] || (_cache[32] = _createElementVNode("span", { class: "tb-tx-dialog-title" }, "Transactions", -1)),
                                    _createElementVNode("button", {
                                        class: "tb-embed-close",
                                        onClick: _cache[8] || (_cache[8] = ($event) => (txDrawerOpen.value = false))
                                    }, [
                                        _createVNode(_component_v_icon, { size: "18" }, {
                                            default: _withCtx(() => _cache[31] || (_cache[31] = [
                                                _createTextVNode("mdi-close")
                                            ])),
                                            _: 1
                                        })
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_30, [
                                    (current.value)
                                        ? (_openBlock(), _createBlock(TransactionsList, {
                                            key: 0,
                                            search: false,
                                            transactions: groupedCurrentTransactions.value,
                                            formatter: _unref(state).formatter,
                                            today: _unref(state).today,
                                            yesterday: _unref(state).yesterday,
                                            categoryPills: true,
                                            onTransactionClick: (t) => { txDrawerOpen.value = false; emit('transaction-click', t); }
                                        }, null, 8, ["transactions", "formatter", "today", "yesterday", "onTransactionClick"]))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ]),
                        _: 1
                    }, 8, ["modelValue"]))
                    : (_openBlock(), _createBlock(SimpleDrawerPanel, {
                        key: 3,
                        modelValue: txDrawerOpen.value,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((txDrawerOpen).value = $event)),
                        title: "Transactions",
                        height: "90vh",
                        closeButton: true,
                        divider: false
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_31, [
                                (current.value)
                                    ? (_openBlock(), _createBlock(TransactionsList, {
                                        key: 0,
                                        search: false,
                                        transactions: groupedCurrentTransactions.value,
                                        formatter: _unref(state).formatter,
                                        today: _unref(state).today,
                                        yesterday: _unref(state).yesterday,
                                        categoryPills: true,
                                        onTransactionClick: (t) => _unref(router).push('/TransactionDetail/' + t.id)
                                    }, null, 8, ["transactions", "formatter", "today", "yesterday", "onTransactionClick"]))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _: 1
                    }, 8, ["modelValue"])),
                _createVNode(SimpleDrawerPanel, {
                    modelValue: groupInfoOpen.value,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((groupInfoOpen).value = $event)),
                    title: "View transactions",
                    height: "auto",
                    closeButton: true,
                    divider: false
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_32, [
                            _cache[38] || (_cache[38] = _createElementVNode("p", { class: "tb-info-intro" }, "Make the most of spending analysis by accurately categorising your transactions.", -1)),
                            _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                    _createElementVNode("div", _hoisted_35, [
                                        _createElementVNode("img", {
                                            src: require('@/assets/transactions/swipe.png'),
                                            class: "tb-info-icon-img",
                                            alt: ""
                                        }, null, 8, _hoisted_36)
                                    ]),
                                    _cache[33] || (_cache[33] = _createElementVNode("h3", { class: "tb-info-title" }, "Card view", -1))
                                ]),
                                _cache[34] || (_cache[34] = _createElementVNode("h4", { class: "tb-info-subhead" }, "Group transactions", -1)),
                                _cache[35] || (_cache[35] = _createElementVNode("p", null, "Best when all transactions from the same merchant would share a category.", -1)),
                                _cache[36] || (_cache[36] = _createElementVNode("h4", { class: "tb-info-subhead" }, "Individual transactions", -1)),
                                _cache[37] || (_cache[37] = _createElementVNode("p", null, "Best when transactions from the same merchant span multiple categories.", -1))
                            ]),
                            _cache[39] || (_cache[39] = _createElementVNode("div", { class: "tb-info-section" }, [
                                _createElementVNode("div", { class: "tb-info-head" }, [
                                    _createElementVNode("div", { class: "tb-info-icon" }, [
                                        _createElementVNode("svg", {
                                            class: "tb-info-icon-img tb-view-list",
                                            viewBox: "0 0 40 40",
                                            fill: "currentColor",
                                            "aria-hidden": "true"
                                        }, [
                                            _createElementVNode("rect", {
                                                x: "5",
                                                y: "9",
                                                width: "30",
                                                height: "6",
                                                rx: "3"
                                            }),
                                            _createElementVNode("rect", {
                                                x: "5",
                                                y: "17",
                                                width: "30",
                                                height: "6",
                                                rx: "3"
                                            }),
                                            _createElementVNode("rect", {
                                                x: "5",
                                                y: "25",
                                                width: "30",
                                                height: "6",
                                                rx: "3"
                                            })
                                        ])
                                    ]),
                                    _createElementVNode("h3", { class: "tb-info-title" }, "List view")
                                ]),
                                _createElementVNode("p", null, "Switch to list view by using the toggle. You can search & select multiple transactions. Sorted by date.")
                            ], -1))
                        ])
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                (_ctx.embedded)
                    ? (_openBlock(), _createBlock(ChangeCategoryDialog, {
                        key: 4,
                        ref_key: "drawer",
                        ref: drawer,
                        merchantName: drawerMerchantName.value,
                        currentClassification: null,
                        currentExcludeFromAnalysis: excludeFromAnalysis.value,
                        onApply: onPickedFromDrawer
                    }, null, 8, ["merchantName", "currentExcludeFromAnalysis"]))
                    : (_openBlock(), _createBlock(ChangeCategoryDrawer, {
                        key: 5,
                        ref_key: "drawer",
                        ref: drawer,
                        merchantName: drawerMerchantName.value,
                        currentClassification: null,
                        currentExcludeFromAnalysis: excludeFromAnalysis.value,
                        selectableTags: availableTags.value ?? [],
                        currentTags: [],
                        onApply: onPickedFromDrawer
                    }, null, 8, ["merchantName", "currentExcludeFromAnalysis", "selectableTags"])),
                (_ctx.embedded)
                    ? (_openBlock(), _createBlock(_component_v_dialog, {
                        key: 6,
                        "model-value": excludeDialogVisible.value,
                        "onUpdate:modelValue": onExcludeDrawerToggle,
                        "max-width": "420",
                        scrim: "rgba(0, 0, 0, 0.5)"
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("h3", _hoisted_38, _toDisplayString(excludeFromAnalysis.value ? 'Exclude' : 'Include') + " transaction", 1),
                                _createElementVNode("div", _hoisted_39, [
                                    _createElementVNode("p", _hoisted_40, [
                                        _createTextVNode("Would you like to always " + _toDisplayString(excludeFromAnalysis.value ? 'exclude' : 'include') + " transactions", 1),
                                        (currentMerchantName.value)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _cache[40] || (_cache[40] = _createTextVNode(" from ")),
                                                _createElementVNode("strong", null, _toDisplayString(currentMerchantName.value), 1)
                                            ], 64))
                                            : _createCommentVNode("", true),
                                        _cache[41] || (_cache[41] = _createTextVNode("?"))
                                    ]),
                                    _createVNode(MGButton, {
                                        text: `Yes, always ${excludeFromAnalysis.value ? 'exclude' : 'include'}`,
                                        fullWidth: true,
                                        onClick: _cache[12] || (_cache[12] = ($event) => (confirmAlwaysExcludeInclude(true)))
                                    }, null, 8, ["text"]),
                                    _createVNode(MGButton, {
                                        stacked: true,
                                        text: "No, just this once",
                                        fullWidth: true,
                                        onClick: _cache[13] || (_cache[13] = ($event) => (confirmAlwaysExcludeInclude(false)))
                                    }),
                                    _createVNode(MGButton, {
                                        stacked: true,
                                        text: "Back",
                                        fullWidth: true,
                                        outline: true,
                                        onClick: cancelExcludeChange
                                    })
                                ])
                            ])
                        ]),
                        _: 1
                    }, 8, ["model-value"]))
                    : (_openBlock(), _createBlock(SimpleDrawerPanel, {
                        key: 7,
                        modelValue: excludeDialogVisible.value,
                        "onUpdate:modelValue": [
                            _cache[16] || (_cache[16] = ($event) => ((excludeDialogVisible).value = $event)),
                            onExcludeDrawerToggle
                        ],
                        title: `${excludeFromAnalysis.value ? 'Exclude' : 'Include'} transaction`,
                        height: "auto",
                        closeButton: true,
                        divider: false
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("p", _hoisted_42, [
                                    _createTextVNode("Would you like to always " + _toDisplayString(excludeFromAnalysis.value ? 'exclude' : 'include') + " transactions", 1),
                                    (currentMerchantName.value)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _cache[42] || (_cache[42] = _createTextVNode(" from ")),
                                            _createElementVNode("strong", null, _toDisplayString(currentMerchantName.value), 1)
                                        ], 64))
                                        : _createCommentVNode("", true),
                                    _cache[43] || (_cache[43] = _createTextVNode("?"))
                                ]),
                                _createVNode(MGButton, {
                                    text: `Yes, always ${excludeFromAnalysis.value ? 'exclude' : 'include'}`,
                                    fullWidth: true,
                                    onClick: _cache[14] || (_cache[14] = ($event) => (confirmAlwaysExcludeInclude(true)))
                                }, null, 8, ["text"]),
                                _createVNode(MGButton, {
                                    stacked: true,
                                    text: "No, just this once",
                                    fullWidth: true,
                                    onClick: _cache[15] || (_cache[15] = ($event) => (confirmAlwaysExcludeInclude(false)))
                                }),
                                _createVNode(MGButton, {
                                    stacked: true,
                                    text: "Back",
                                    fullWidth: true,
                                    outline: true,
                                    onClick: cancelExcludeChange
                                })
                            ])
                        ]),
                        _: 1
                    }, 8, ["modelValue", "title"]))
            ], 64));
        };
    }
});
